import React, { useState } from "react";
import { useIntl } from "react-intl";
import ReconciliationPage from "../../components/reconciliation";
import Page from "../../components/general/page";
import VaporFullscreenOverlay from "../../components/vapor/fullscreenOverlay";
import DetailDeadlinesView from "../deadlines/detail";
import { useSelector } from "react-redux";

const ReconciliationView = props => {
  const { pageRef } = props;

  const main = useSelector(state => state.main);
  const company = useSelector(state => state.company);

  const [deadlinesDetailOpened, setDeadlinesDetailOpened] = useState(false);

  const selectedCompanyName = company?.companies?.find(el => el.id === main.clientIdSelected);

  const intl = useIntl();

  return (
    <React.Fragment>
      {deadlinesDetailOpened && (
        <VaporFullscreenOverlay
          title="SCADENZA"
          subtitle="DETTAGLIO SCADENZA"
          width={"95vw"}
          deadlineId={deadlinesDetailOpened}
          onClose={() => setDeadlinesDetailOpened(null)}
        >
          <DetailDeadlinesView            
            isFullscreenOverlay={true}
          />
        </VaporFullscreenOverlay>
      )}
      <Page
        pageRef={pageRef}
        title={useIntl().formatMessage({ id: "reconciliation.title" })}
        subtitle={
          selectedCompanyName?.ragioneSociale + " / " + intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" }) + " " + main.companySelected
        }
        className={"contentStructure transparent"}
        subClassName="pageCss"
        backText=""
        backRewind        
      >
        <ReconciliationPage
          openDeadlineDetail={deadlineId =>
            setDeadlinesDetailOpened(deadlineId)
          }          
        />
      </Page>
    </React.Fragment>
  );
};

export default ReconciliationView;
